export default "__VITE_ASSET__Bvb7nYXz__"